import { Directive, ElementRef, Renderer2, forwardRef, Input, OnInit, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlessInputTextDirective } from '../../shared/input/pless-input-text.directive';
import { PlessViewUtilsSub } from './pless-view-utils-sub.service';

import * as Encoding from 'encoding-japanese';
/**
 * Plessテキスト入力(デリ宅配システムの入力制限機能付き)
 *
 * @export PlessInputTextCoopDeliDirective
 * @class PlessInputTextCoopDeliDirective
 * @extends {PlessInputTextDirective}
 */
@Directive({
  selector: 'input[plessInputTextCoopDeli],textarea[plessInputTextCoopDeli]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PlessInputTextCoopDeliDirective),
      multi: true
    },
  ]
})

export class PlessInputTextCoopDeliDirective extends PlessInputTextDirective implements OnInit, OnChanges  {

  /** 改行を許すかどうかのフラグ */
  @Input() allowMultiLine = true;

  /** アルファベット 大文字変換フラグ */
  @Input() toUpperCase: boolean = <boolean>false;

  /** 非活性フラグ */
  @Input() disabled: boolean = <boolean>false;

  constructor(protected elementRef: ElementRef, protected renderer: Renderer2) {
    super(elementRef, renderer)
  }

  ngOnInit() {
    this.elementRef.nativeElement.disabled = this.disabled;
    super.ngOnInit();
  }

  ngOnChanges() {
    this.elementRef.nativeElement.disabled = this.disabled;
    super.ngOnChanges();
  }

  /**
   * 入力制限処理
   */
  protected doRestrict(value: string) {
    let resultValue = value;
    let resultIndex = this.elementRef.nativeElement.selectionStart;

    // 改行文字を除去する
    if (!this.allowMultiLine) {
      let reqValue = value.replace(/^(\n|\r|\0|\x0B)*/gm, '').replace(/(\n|\r|\0|\x0B)*$/gm, '');
      reqValue = reqValue.replace(/(\n|\r|\0|\x0B)*/gm, '');
      reqValue = reqValue.replace('\r', '');
      reqValue = reqValue.replace('\n', '');

      resultValue = reqValue;
    }

    // 文字を削除した場合は削除後の値を適応
    if (value !== resultValue) {
      this.elementRef.nativeElement.value = resultValue;
    }

    if (PlessViewUtilsSub.isEmptyArray(this.restrictArray) && !this.fullOnly && !this.halfOnly) {
      this.refresh(value);
      return;     // 入力制限が無い場合は処理しない
    }
    if (value == null || value === '') {
      this.refresh(value);
      return;     // 入力値が空の場合は処理しない
    }

    // 全角・半角のみ入力可能な場合
    if (this.fullOnly) {
      // 全角のみ入力可能な場合
      const fullValue = PlessViewUtilsSub.halfToFull(value);
      resultIndex -= (value.length - fullValue.length); // "ｶﾞ"→"ガ" など文字数が減った場合はカーソル位置を調整
      resultValue = fullValue;
    } else if (this.halfOnly) {
      // 半角のみ入力可能な場合
      const halfValue = PlessViewUtilsSub.fullToHalf(value);
      resultIndex -= (value.length - halfValue.length); // "ガ"→ "ｶﾞ" など文字数が増えた場合はカーソル位置を調整
      resultValue = halfValue;
    }

    // 入力制限文字がある場合
    if (!PlessViewUtilsSub.isEmptyArray(this.restrictArray)) {
      const valueArray = `${resultValue}`.split('');
      resultValue = '';
      for (let i = Number(0); i < valueArray.length; i++) {
        // 正規表現チェック
        if (valueArray[i].match(this.restrict)) {
          // 入力可能文字だけ残す
          resultValue += valueArray[i];
        } else if (valueArray[i].toUpperCase().match(this.restrict)) {
          // 小文字が入力された場合、大文字が入力可ならば自動的に大文字にする
          resultValue += valueArray[i].toUpperCase();
        } else if (valueArray[i].toLowerCase().match(this.restrict)) {
          // 大文字が入力された場合、子文字が入力可ならば自動的に子文字にする
          resultValue += valueArray[i].toLowerCase();
        } else {
          // 削除した場合はカーソル位置を調整する
          resultIndex--;
        }
      }
    }
    // Shift-jis 範囲で無い文字は、削除する。
    // 使用可能文字は以下
    // 0x8140～0x8491（非漢字の一部）、0x889F～0x988F（漢字第１水準）、0x9890～0xEAA4（漢字第２水準）
    const valueArray = `${resultValue}`.split('');
    resultValue = '';
    for (let i = 0; i < valueArray.length; i++) {
      const encSjis = Encoding.convert(valueArray[i],'SJIS','AUTO');
      const encSjisCode = Encoding.stringToCode(encSjis);
      if (!(encSjis === '?' )) {                                          // SJIS 変換可能文字の場合
        if (encSjisCode.length === 2) {                                   // 2bytes系文字のチェック
          // 文字コードの範囲チェックを行い、範囲内のみ入力可能とする。
          // チェック1 0x8140～0x8491（非漢字の一部）のチェック
          if (encSjisCode[0] >= 129 && encSjisCode[0] <= 131) {           // 129 = 0x81, 13 = 0x83
            // チェック1-1 1byte目 81xx～83xx の場合
            if (encSjisCode[1] >= 64 && encSjisCode[1] <= 255) {          // 64 = 0x40, 255 = 0xFF
              // チェック1-1-1 2byte目 xxが40～FF の場合
              resultValue += valueArray[i];                               //入力可能文字のみ応答用に保存する
              continue;
            }
          } else if (encSjisCode[0] === 132) {                            // 132 = 0x84
            // チェック1-2 1byte目 84xx の場合
            if (encSjisCode[1] >= 64 && encSjisCode[1] <= 145) {          // 64 = 0x40, 145 = 0x91
              // チェック1-2-1 2byte目 xxが40～91 の場合
              resultValue += valueArray[i];                               //入力可能文字のみ応答用に保存する
              continue;
            }
          }

          // チェック2 0x889F～0x988F（漢字第１水準）のチェック
          if (encSjisCode[0] === 136) {                              // 136 = 0x88
            // チェック2-1 1byte目 88xx の場合
            if (encSjisCode[1] >= 159 && encSjisCode[1] <= 255) {         // 159 = 0x9F, 255 = 0xFF
              // チェック2-1-1 2byte目 xxが9F～FF の場合
              resultValue += valueArray[i];                               //入力可能文字のみ応答用に保存する
              continue;
            }
          } else if (encSjisCode[0] >= 137 && encSjisCode[0] <= 151) {    // 137 = 0x89, 151 = 0x97
            // チェック2-2 1byte目 89xx～97xx の場合
            if (encSjisCode[1] >= 64 && encSjisCode[1] <= 255) {          // 64 = 0x40, 255 = 0xFF
              // チェック2-2-1 2byte目 xxが40～FF の場合
              resultValue += valueArray[i];                               //入力可能文字のみ応答用に保存する
              continue;
            }
          } else if (encSjisCode[0] === 152) {                            // 152 = 0x98
            // チェック2-3 1byte目 98xx の場合
            if (encSjisCode[1] >= 64 && encSjisCode[1] <= 143) {          // 64 = 0x40, 143 = 0x8F
              // チェック2-3-1 2byte目 xxが40～8F の場合
              resultValue += valueArray[i];                               //入力可能文字のみ応答用に保存する
              continue;
            }
          }

          // チェック3 0x9890～0xEAA4（漢字第２水準）のチェック
          if (encSjisCode[0] === 152) {                                   // 152 = 0x98
            // チェック3-1 1byte目 98xx の場合
            if (encSjisCode[1] >= 144 && encSjisCode[1] <= 255) {         // 144 = 0x90, 255 = 0xFF
              // チェック3-1-1 2byte目 xxが90～FF の場合
              resultValue += valueArray[i];                               //入力可能文字のみ応答用に保存する
              continue;
            }
          } else if (encSjisCode[0] >= 153 && encSjisCode[0] <= 233) {    // 153 = 0x99, 233 = 0xE9
            // チェック3-2 1byte目 99xx～E9xx の場合
            if (encSjisCode[1] >= 64 && encSjisCode[1] <= 255) {          // 64 = 0x40, 255 = 0xFF
              // チェック3-2-1 2byte目 xxが40～FF の場合
              resultValue += valueArray[i];                               //入力可能文字のみ応答用に保存する
              continue;
            }
          } else if (encSjisCode[0] === 234) {                            // 234 = 0xEA
            // チェック3-3 1byte目 EAxx の場合
            if (encSjisCode[1] >= 64 && encSjisCode[1] <= 164) {          // 64 = 0x40, 164 = 0xA4
              // チェック3-3-1 2byte目 xxが40～A4 の場合
              resultValue += valueArray[i];                               //入力可能文字のみ応答用に保存する
              continue;
            }
          }
        } else if (encSjisCode.length === 1) {        // 1バイト系文字は、入力可
          resultValue += valueArray[i];               // 入力可能文字のみ応答用に保存する
        }
      }
    }

    // アルファベット大文字変換フラグがtrueなら大文字に変換する
    if (this.toUpperCase) {
      resultValue = resultValue.toUpperCase();
    }

    // 文字の変換で文字数が増えた場合に入力文字数制限を超えていたら
    // 超えた文字数分末尾からカットする
    const maxLength = this.elementRef.nativeElement.maxLength;
    if (maxLength != null
        && maxLength !== -1
        && maxLength < resultValue.length) {
      resultValue = resultValue.slice(0, maxLength - resultValue.length);
    }

    // 文字を削除した場合は削除後の値を適応
    if (value !== resultValue) {
      this.elementRef.nativeElement.value = resultValue;
      this.elementRef.nativeElement.selectionStart = resultIndex;
      this.elementRef.nativeElement.selectionEnd = resultIndex;
    }

    this.refresh(resultValue);
  }
}
